<template>
    <type-based-transition :transitionType="'fadeUpDown'">
        <div v-if="isComplete" id="complete" class="form-complete">
            <h1>Grazie!<small><br/>per aver compilato il nostro modulo</small></h1>

            <div class="" style="max-width: 90%;">
            <p class="text-center pb-1" style="display: block;margin:0px auto;">Ora controlla i tuoi dati se è tutto corretto clicca su <b>ISCRIVITI</b></p>
            <div class="scrollable">
                <p v-for="(item, key, index) in $store.state.lead.formData">
                    <span v-colorswatch:color="index"> {{ key }}: </span> {{ item }}
                </p>
            </div>
            </div>

            <div class="text-center">
                <div class="form-button primary" style="max-width: 50%; margin:0px auto;" @click="$root.$emit('sendForm',formState)">Iscriviti ora</div>
                <small>Inviando questo modulo di iscrizione dichiari di aver preso visione della <a href="https://www.infaop.com/privacy-policy" target="_blank">privacy policy</a> di INFAOP.</small>
            </div>
        </div>
    </type-based-transition>
</template>
<script>
import TypeBasedTransition from "../Transitions/TypeBasedTransition.vue"

export default {
    name: "form-result",
    inject: ["formState"],
    components: {
        TypeBasedTransition
    },
    computed: {
        isComplete() {
            return this.formState.isComplete
        }
    }
}
</script>
